<template>
  <custom-dialog :visible="visible" width="1200px" :title="model.title" v-on="$listeners">
    <div class="dialog-body">
      <div class="change-device-dialog">
        <div>
          <h1 class="item-title">{{ $t('asm_part_changePayer_dialog.ling_jian_xin_xi') }}</h1>
          <div class="item-title-info">
            <el-row>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.geng_huan_shi_jian') }}:</span>
                <span class="value">{{ $momentLocal(info.replaceTime) || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.ling_jian_lei_bie') }}:</span>
                <span class="value">{{ getDicValue('asm_part_class', info.partClass) || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.ling_jian_lei_xing') }}:</span>
                <span class="value">{{ getDicValue('asm_part_type', info.partType) || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.geng_huan_ren') }}:</span>
                <span class="value">{{ info.creator || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.ling_jian_bian_hao') }}:</span>
                <span class="value">{{ info.partCode || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.ling_jian_ming_cheng') }}:</span>
                <span class="value">{{ info.partName || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.jiu_ling_jianSN') }}:</span>
                <span class="value">{{ info.oldPartSn || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.xin_ling_jianSN') }}:</span>
                <span class="value">{{ info.partSn || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.ling_jian_shu_liang') }}:</span>
                <span class="value">{{ info.replaceNum || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.ling_jian_zong_jia') }}:</span>
                <span class="value">{{ info.finalPayment || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.shi_yong_shi_changH') }}:</span>
                <span class="value">{{ info.usageMinuteTotal || '-' }}</span>
              </el-col>
              <el-col :span="6">
                <span class="label">{{ $t('asm_part_changePayer_dialog.li_lun_shou_mingH') }}:</span>
                <span class="value">{{ info.theoryUseTime || '-' }}</span>
              </el-col>
            </el-row>
          </div>
          <!-- <h1 class="item-title">{{ $t('p_workorderDetail_fu_kuan_fang') }}</h1> -->
          <el-form :model="form" size="small" ref="form" label-position="top">
            <el-form-item :label="$t('asm_part_changePayer_dialog.fu_kuan_fang')" prop="paymentOrg" :rules="rules.paymentOrg">
              <custom-select v-model="form.paymentOrg" code="asm_part_replace_payment_org" :placeholder="i18n.com_please_select" width="320px"></custom-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button size="small" type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      info: {},
      form: {
        orderPartId: '',
        paymentOrg: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        paymentOrg: [{ required: true, message: this.$t('asm_part_changePayer_dialog.qxzfkf') }],
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.info = this.model.row;
        this.form.orderPartId = this.info.orderPartId;
        this.form.paymentOrg = this.info.paymentOrg || '';
        // this.getOrderInfo();
        // this.getDeviceList();
      }
    },
    // 订单信息
    getOrderInfo: function () {
      this.$getJSON(apis.ChangeOrderInfo, {
        orderId: this.model.changeId,
      }).then((res) => {
        this.detail = res.data;
      });
    },

    // 确认保存
    onConfirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.$postJSON(apis.workOrderPartPaymentOrgChange, this.form).then(() => {
          this.$message({
            message: this.$t('Common.com_handle_success'),
            type: 'success',
          });
          this.$emit('success');
          this.closeDialog();
        });
      });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
  },
};
</script>

<style lang="scss"></style>
